import { PlusCircleIcon } from "lucide-react";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui/components/Base/Dialog";
import { TeamMemberForm } from "./TeamMemberForm";

export const AddTeamMemberDialog = ({
  tenantId,
  teamId,
}: {
  tenantId: string;
  teamId: string;
}) => {
  const [open, setOpen] = useState(false);
  const handleOpenChange = () => setOpen(!open);
  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger className="flex flex-row gap-2 p-2 rounded-lg hover:scale-110 duration-100 shadow-2xl">
        <PlusCircleIcon />
      </DialogTrigger>
      <DialogContent preventClickout preventEscape>
        <DialogHeader>
          <DialogTitle>Add a New Team Member</DialogTitle>
        </DialogHeader>

        <TeamMemberForm
          tenantId={tenantId}
          teamId={teamId}
          handleCancel={handleOpenChange}
          handleComplete={handleOpenChange}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
